
const initialState = {
  history: [],
  currentHistoryIndex: 0,
  isUpdating: false,
  fetchedHistory: false
};

function configReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_HISTORY_SUCCESS':
      return {
        ...state,
        ...action.payload,
        currentHistoryIndex: action.payload.history.length - 1,
        fetchedHistory: true,
      };
    case 'UPDATE_HISTORY_ITEM':
      function insertItem(array, action) {
          let newArray = array.slice();
          newArray.splice(action.payload.currentHistoryIndex, 1, action.payload.updatedHistoryItem);
          return newArray;
      }
      const updatedHistoryArray = insertItem(state.history, action)
      return {
        ...state,
        history: updatedHistoryArray
      }

    case 'CREATE_ACCOUNT_REQUEST':
      return {
        ...state,
        isUpdating: true,
      };
    case 'CREATE_ACCOUNT_SUCCESS':
      return {
        ...state,
        ...action.payload,
        isUpdating: false,
      };

    case 'CLONE_HISTORY_SUCCESS':
      return {
        ...state,
        ...action.payload,
      };

    case 'DELETE_ACCOUNT_REQUEST':
      return {
        ...state,
        isUpdating: true,
      };
    case 'DELETE_ACCOUNT_SUCCESS':
      return {
        ...state,
        ...action.payload,
        isUpdating: false,

      };
    case 'UPDATE_ACCOUNT_REQUEST':
      return {
        ...state,
        ...action.payload,
        isUpdating: true,
      };
    case 'UPDATE_ACCOUNT_SUCCESS':
      return {
        ...state,
        ...action.payload,
        isUpdating: false,
      };
    case 'SHOW_PREVIOUS_MONTH':
      return {
        ...state,
        currentHistoryIndex: state.currentHistoryIndex - 1,
      };
    case 'SHOW_NEXT_MONTH':
      return {
        ...state,
        currentHistoryIndex: state.currentHistoryIndex + 1,
      };
    default:
      return state;
  }
}
export default configReducer;



// WEBPACK FOOTER //
// ./src/reducers/history-reducer.js